import React from 'react';

const withScrollHandler = (Component, config: any) => {
    return class EnhancedComponent extends React.Component {

        state = {
            scrollpos: config.scrollinit,
            minpos: config.minpos || 77,
            bgimage: { background: `linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%), url('/assets/img/${config.namebg}') no-repeat center center / cover` }
        }

        handleScroll = (e: any) => {

            let posmin = window.innerHeight - e.target.scrollHeight;
            if (e.target.scrollTop > 0) {

                this.setState({ scrollpos: posmin > this.state.minpos ? posmin : this.state.minpos })
                // setScrollpos();
            } else {

                this.setState({ scrollpos: config.scrollinit })
                // setScrollpos(260);
            }

        }

        render() {
            return (
                <Component scrollpos={this.state.scrollpos} handleScroll={this.handleScroll} bgimage={this.state.bgimage} />
            )
        }
    }
}

export default withScrollHandler;